<template>
  <div class="row">
    <div class="col-md-12">

      <h4 v-if=" getCategory != 'infantil' ">{{ $t('Buscador Avanzado Música') }} </h4>
      
      <div class="row buscador-avanzado">
        <div class="col-md-6">          
          <div class="form-head fix">

            <input-autocomplete
              :title="$t('Título')" 
              searchField="TITULO" 
              searchCategory="musica" :value.sync="frm.TITULO"
              :reset="reset">
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Intérprete')" 
              searchField="M_INTERPRETES" 
              searchCategory="musica" :value.sync="frm.M_INTERPRETES"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Compositor/a')" 
              searchField="M_COMPOSITORES" 
              searchCategory="musica" :value.sync="frm.M_COMPOSITORES"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('País/zona')" 
              searchField="M_PAISES" 
              searchCategory="musica" :value.sync="frm.M_PAISES"
              :reset="reset">
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Sello')" 
              searchField="EDITOR" 
              searchCategory="musica" :value.sync="frm.EDITOR"
              :reset="reset">      
            </input-autocomplete>

          </div>
        </div>

        <div class="col-md-6">
          
          <div class="input-group">
            <div class="input-group-addon"><span>{{ $t('Año lanzamiento') }}</span></div>
            <input type="number" class="form-control" :placeholder="$t('Año lanzamiento')" maxlength="150" v-model="frm.M_ANO_LANZAMIENTO">
          </div>

          <input-autocomplete
            :title="$t('Estilo')" 
            searchField="M_ESTILOS" 
            searchCategory="musica" :value.sync="frm.M_ESTILOS"
            :reset="reset">      
          </input-autocomplete>

          <custom-select-box 
            :title="$t('Formato')" 
            searchField="FORMATO" 
            searchCategory="musica" :value.sync="frm.FORMATO"
            :reset="reset">
          </custom-select-box>
          
          <div class="row">
            <div class="col-xs-6">
              <div class="input-group mr10">
                <div class="input-group-addon"><span>{{ $t('Precio min') }}</span></div>
                <input type="number" class="form-control" :placeholder="$t('Precio min')" maxlength="150" v-model="frm.PRECIO_MIN">
              </div>
            </div>
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Precio max') }}</span></div>
                <input type="number" class="form-control" :placeholder="$t('Precio max')" maxlength="150" v-model="frm.PRECIO_MAX">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Novedad') }}</span></div>
                <input type="checkbox" v-model="frm.NOVEDAD">
              </div>
            </div>
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Recomendado') }}</span></div>
                <input type="checkbox" v-model="frm.RECOMENDADO">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

            <div class="center">
              <button class="btn btn-tata mb40" type="submit" @click="resetForm">{{ $t('Vaciar') }} <i class="fa fa-remove"></i></button>
              <button class="btn btn-tata mb40" type="submit" @click="submitSearch">{{ $t('Buscar') }} <i class="fa fa-search"></i></button>
            </div>
        </div>
      </div>
      
<!-- <pre>{{ reset }}</pre> -->
    </div>  
  </div>
</template>

<i18n>
{
  "es": {
  	"Buscador Avanzado Música": "Buscador Avanzado Música",
    "Título": "Título",
    "Intérprete": "Intérprete",
    "Compositor/a": "Compositor/a",
    "País/zona": "País/zona",
    "Sello": "Sello",
    "Año lanzamiento": "Año lanzamiento",
    "Estilo": "Estilo",
    "Formato": "Formato",
    "Precio min": "Precio min",
    "Precio max": "Precio max",
    "Novedad": "Novedad",
    "Recomendado": "Recomendado",
    "Debe rellenar un campo como mínimo": "Debe rellenar un campo como mínimo",
    "Buscar": "Buscar",
    "Vaciar": "Vaciar"
  },
  "en": {
  },
  "ca": {
    "Buscador Avanzado Música": "Cercador avançat Música",
    "Título": "Títol",
    "Intérprete": "Intèrpret",
    "Compositor/a": "Compositor/a",
    "País/zona": "País/zona",
    "Sello": "Segell",
    "Año lanzamiento": "Any llançament",
    "Estilo": "Estil",
    "Formato": "Format",
    "Precio min": "Preu mín",
    "Precio max": "Preu màx",
    "Novedad": "Novetat",
    "Recomendado": "Recomanat",
    "Debe rellenar un campo como mínimo": "Ha d'omplir com a mínim un camp",
    "Buscar": "Cercar",
    "Vaciar": "Buidar"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';
  import CustomSelectBox from './CustomSelectBox.vue';
  import InputAutocomplete from './InputAutocomplete.vue';

  export default {
    props: ['searchCategory'],
    components: { CustomSelectBox, InputAutocomplete },
    data: () => {
      return{
        loading: false,
        frm_error: false,
        frm_error_message: '',
        frm: {
          TITULO: '',
          M_INTERPRETES: '',
          M_COMPOSITORES: '',
          M_PAISES: '',
          EDITOR: '',
          M_ANO_LANZAMIENTO: '',
          M_ESTILOS: '',
          FORMATO: '',        
          PRECIO_MIN: '',
          PRECIO_MAX: '',
          NOVEDAD: false,
          RECOMENDADO: false,
          a_tipo: ''
        },
        reset: false,
      }
    },
    mounted(){
    },
    computed: mapGetters(['getLocale', 'getApiUrl', 'getCategory']), 
    methods: {
      submitSearch() {
        this.frm_error = false;

        if( this.searchData() ){

          this.frm.a_tipo = (this.searchCategory) ? this.searchCategory.substr(0,1) : '';
          this.frm.NOVEDAD = (this.frm.NOVEDAD == false) ? '' : true;
          this.frm.RECOMENDADO = (this.frm.RECOMENDADO == false) ? '' : true;

          // COPIAR VARIABLES RELLENADAS
          let dataToSend = {};
          for (var prop in this.frm) {
            if (this.frm.hasOwnProperty(prop)) {
              if( this.frm[prop] != '' ){
                dataToSend[prop] = this.frm[prop];
              }
            }
          }

          // Añadir ref para stats
          dataToSend['ref'] = 'buscador_avanzado';

          this.$router.push({ 
            name: 'buscador-avanzado', 
            params: { language: this.getLocale, category: this.getCategory },
            query: dataToSend
          })

        }else{
          this.frm_error_message = this.$t('Debe rellenar un campo como mínimo');
          this.frm_error = true;
        }
      },
      searchData(){
        for (var prop in this.frm) {
          if (this.frm.hasOwnProperty(prop)) {
            if( this.frm[prop] != '' && prop != 'a_tipo' ){
              return true;
            }
          }
        }
        return false;
      },
      resetForm(){
        this.reset = !this.reset;
        this.frm.FECHA_SALIDA = this.frm.PRECIO_MIN = this.frm.PRECIO_MAX = this.frm.M_ANO_LANZAMIENTO = '';
        this.frm.NOVEDAD = this.frm.RECOMENDADO = false;
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
    }
  }
</script>
